var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-main"}},[_c('keep-alive',[_c('router-view',{key:_vm.key})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }